import React from 'react'
import { func, oneOf, node, string } from 'prop-types'

const BackDrop = (props) => {
  const {
    className, onClick, color, children,
  } = props

  return (
    <div
      className={`asda-backdrop ${className || ''}`}
      data-color={color}
      onClick={onClick}
      role="presentation"
      data-testid="asda-backdrop"
    >
      { children }
    </div>
  )
}

BackDrop.propTypes = {
  className: string,
  children: node,
  onClick: func,
  color: oneOf(['black', 'transparent']),
}

BackDrop.defaultProps = {
  className: null,
  children: null,
  onClick: () => {},
  color: 'black',
}

export default BackDrop
